import React from 'react';
import { AmrSearchFiltersVerticalComponent } from './amr/amr-search-filters-vertical.component';
import { CtSearchFiltersVerticalComponent } from './ct/ct-search-filters-vertical.component';
import { useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';

export const SearchFiltersVerticalComponent = () => {
    const { isAmr } = useAssignedAppTypeContext();

    if (isAmr) {
        return <AmrSearchFiltersVerticalComponent />;
    }

    return <CtSearchFiltersVerticalComponent />;
};
